export default __webpack_public_path__ + "static/media/not-found.204f7384.png";